import { Form, Formik, FormikValues } from "formik";
import { Button, Card, Input, Select } from "../../custom";
import styles from "./styles.module.scss";
import { useMutation, useQueries } from "@tanstack/react-query";
import api from "../../utils/api";
import { App, Spin } from "antd";
import { createOrUpdateContactForm } from "./request";
import { useAtomValue } from "jotai";
import { userAtom } from "../../utils/store";

import * as Yup from "yup";

const ContactUs = () => {
  const { notification } = App.useApp();
  const user = useAtomValue(userAtom);

  const contactFormMutation = useMutation({
    mutationKey: ["contactForm"],
    mutationFn: createOrUpdateContactForm,
  });

  const handleContactForm = async (
    values: FormikValues,
    resetForm: () => void
  ) => {
    const payload: Partial<ContactForm> = {
      applicantId: user?.applicantId,
      title: values.title,
      fName: values.fName,
      lName: values.lName,
      email: values.email,
      phone: values.phone,
      message: values.message,
    };

    try {
      await contactFormMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });
          // Reset the form on success
          resetForm();
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const [titleQuery] = useQueries({
    queries: [
      {
        queryKey: ["get-title"],
        queryFn: async () =>
          (await api.get("/Utilities/Utilities/GetAllTitle"))
            ?.data as TitleResponse,
      },
    ],
  });

  const TitleOptions = titleQuery?.data?.data?.map((item: Title) => {
    if (titleQuery?.isLoading) {
      return <option value="">{<Spin size="small" />}</option>;
    } else {
      return (
        <option key={item?.id} value={item?.titleName}>
          {item?.titleName}
        </option>
      );
    }
  });
  // const TitleOptions =
  //   titleQuery?.data?.data && titleQuery?.data?.data?.length > 0 ? (
  //     titleQuery?.data?.data?.map((item: Title, index: number) => (
  //       <option value={item?.titleName} key={index}>
  //         {item?.titleName}
  //       </option>
  //     ))
  //   ) : (
  //     <option disabled>{titleQuery?.isLoading ? "loading" : "error"}</option>
  //   );

  const validationSchema = Yup.object().shape({
    fName: Yup.string().required("First Name name is required"),
    lName: Yup.string().required("Last Name is required"),
    phone: Yup.number().required("Phone Number is required"),
    title: Yup.string().required("Title is required"),
    email: Yup.string().required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  return (
    <div>
      <section className={styles.banner}>
        <h1>Contact Us</h1>
      </section>

      <section className={styles.contactForm}>
        <p>
          Please complete the form below with details of your request. We’ll get
          back to you by email, so make sure you <br /> include the right email
          address.
        </p>

        <div>
          <div>
            <Card>
              <h3>Contact Form</h3>

              <div className={styles.formContent}>
                <div>
                  <Formik
                    initialValues={{
                      title: "",
                      fName: "",
                      lName: "",
                      phone: "",
                      message: "",
                      email: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { resetForm }) => {
                      handleContactForm(values, resetForm);
                    }}>
                    {({ handleChange, setFieldValue }) => {
                      return (
                        <Form>
                          <div className={styles.formStyle}>
                            <Select
                              name="title"
                              label="Title"
                              placeholder="Title"
                              options={TitleOptions}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("title", e.target.value);
                              }}
                            />
                            <Input
                              name="fName"
                              label="First Name:"
                              placeholder="First Name"
                            />
                            <Input
                              name="lName"
                              label="Last Name:"
                              placeholder="Last Name"
                            />
                            <Input
                              type="email"
                              name="email"
                              label="Email:"
                              placeholder="Email"
                            />
                            <Input
                              type="phone"
                              name="phone"
                              label="Phone:"
                              placeholder="Phone Number"
                            />
                            <Input
                              type="textarea"
                              name="message"
                              label="Message"
                              placeholder="Comment/Enquiry Details"
                            />
                          </div>

                          <div className={styles.button}>
                            <Button
                              text="Submit"
                              type="submit"
                              disabled={contactFormMutation.isPending}
                              isLoading={contactFormMutation?.isPending}
                            />
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;